
import { Tabs, Tab, Box, Divider, Grid, Typography, Tooltip, Autocomplete, FormControl, FormLabel, RadioGroup, Radio, InputLabel, Select, MenuItem, FormControlLabel, Checkbox, TextField, IconButton, InputAdornment, useTheme, Button, Toolbar } from "@mui/material";


import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { styled } from '@mui/material/styles';
import React, { useState, useEffect, useRef } from "react";
import Cancel from '@mui/icons-material/CancelOutlined';
import AddCircleIcon from '@mui/icons-material/AddCircleOutlineOutlined';
import PropTypes from 'prop-types';
import Header from "../../../Layout/Header";



import 'dayjs/plugin/customParseFormat';



import CallAlertBar from "../../../Layout/Alertbar";

import SaveAltIcon from '@mui/icons-material/SaveAlt';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';

import useUOM from "../../../hooks/useUOMList";
import useMaterialCategory from "../../../hooks/useMaterialCategory";
import useMaterialCode from "../../../hooks/useMaterialCode";
import useMaterialDetail from "../../../hooks/useMaterialDetail";
import useReOrderLevelCalculation from "../../../hooks/useMaterialWiseMinimumReOrderLevelCalculation";
import SwipeableViews from 'react-swipeable-views';
import MaterialWiseVendor from "./MaterialWiseVendor";
import { tokens } from "../../../theme/theme";
import { callApi } from "../../../utils/apiClient";
import { API_ENDPOINTS } from "../../../config/api/apiCall";
import AddCategory from "../../master/AddCategory";
import AddMaterialShade from "../../master/AddMaterialShade";
import useMaterialShades from "../../../hooks/useMaterialShades";
import { set } from "date-fns";

import AddUpdateMaterialAttributes from "../../master/AddUpdateMaterialAttributes";
import DynamicFormByCategory from "../../master/DynamicFormByCategory";
import useMaterialSubCategory from "../../../hooks/useMaterialSubCategory";
import AddSubCategory from "../../master/AddSubCategory";
import TooltipLabel from "../../../components/common/TooltipLabel";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `full-width-tab-${index}`,
    'aria-controls': `full-width-tabpanel-${index}`,
  };
}





const AddNewMaterial = ({ handlecallback, editMaterialID, setEditMaterialID }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const [value, setValue] = React.useState(0);

  // Parent Roll  Alert Values
  const [parentRollMsgOpen, setParentRollMsgOpen] = useState(false);
  const [parentRollSeverityvalue, setParentRollSeverityvalue] = useState('info');
  const [parentRollMessageValue, setParentRollMessageValue] = useState('Welcome to Paper Roll Booking! ');
  const [parentRollAlertTitleValue, setParentRollAlertTitleValue] = useState('');

  // List of Parameter

  const [materialName, setMaterialName] = useState('');
  const [minimumReOrderQty, setMinimumReOrderQty] = useState(0);

  const [leadTimeDemand, setLeadTimeDemand] = useState(0);
  const [safetyStock, setSafetyStock] = useState(0);
  const [vendors, setVendors] = useState([]);
  const [hsncode, setHsncode] = useState('');
  const [gstpercentage, setGstpercentage] = useState(0);

  const [selectedButtonName, setSelectedButtonName] = useState('');

  const { uom, selectedUOM, selectedUOMID, setSelectedUOM, setSelectedUOMID, loadUOMByID } = useUOM(editMaterialID);
  const { materialCategory, selectedCategory, selectedCategoryID, setSelectedCategory, setSelectedCategoryID, loadMaterialCategoryByID } = useMaterialCategory(editMaterialID);
  const { materialSubCategory, selectedSubCategory, selectedSubCategoryID, setSelectedSubCategory, setSelectedSubCategoryID, loadMaterialSubCategoryByID } = useMaterialSubCategory(editMaterialID);

  const { materialCode, setMaterialCode, generateMaterialCodeByCategory } = useMaterialCode(editMaterialID);

  const { materialDetail, setMaterialDetail, loadMaterialDetailByID } = useMaterialDetail();
  const { materialShade, selectedShade, selectedShadeID, setSelectedShade, setSelectedShadeID, loadMaterialShadeByID } = useMaterialShades(editMaterialID);



  const { minimumReOrderLevel, setMinimumReOrderLevel, calculateReOrderLevel } = useReOrderLevelCalculation();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const purchaseOptions = ['Import', 'Export', 'Domestic'];
  const [purchaseType, setPurchaseType] = useState('Import'); // default value

  const [isModalOpenShadeMaster, setIsModalOpenShadeMaster] = useState(false);
  const [error, setError] = useState('');

  const [isModalOpenCategoryAttr, setIsModalOpenCategoryAttr] = useState(false);
  const [formData, setFormData] = useState({});

  const [isModalOpenSubCategory, setIsModalOpenSubCategory] = useState(false);
  const createSubCategoryBtnRef = useRef(null);
  const [showTooltip, setShowTooltip] = useState(false);
  const [tooltipInfo, setTooltipInfo] = useState('');

  const handleOpenModal = () => {
    setIsModalOpen(true);
  };
  const handleOpenModalSubCategory = () => {
    setIsModalOpenSubCategory(true);
  };

  const handleOpenModalShadeMaster = () => {
    setIsModalOpenShadeMaster(true);
  };

  const handleOpenModalCategoryAttr = () => {
    setIsModalOpenCategoryAttr(true);

  };

  const handleChange = (e) => {
    const value = e.target.value;
    setHsncode(value);

  };

  const handleChangeIndex = (index) => {
    setValue(index);
  };

  useEffect(() => {
    if (editMaterialID !== 0) {
      const loadMaterial = async () => {
        await loadMaterialDetailByID(editMaterialID);
        setHideAdd(false);

      };
      loadMaterial();
    }
  }, [editMaterialID]);

  const convertAttributesToObject = (raw) => {
    if (!raw) return {};               // null/undefined guard
    let arr = raw;

    // If backend sends a JSON string, parse it
    if (typeof raw === "string") {
      try {
        arr = JSON.parse(raw);
      } catch {
        console.error("Bad JSON in material_attributes:", raw);
        return {};
      }
    }

    // If it’s still not an array, bail out
    if (!Array.isArray(arr)) return {};

    return arr.reduce((acc, { attribute_name, value_text }) => {
      acc[attribute_name] = value_text;
      return acc;
    }, {});
  };


  useEffect(() => {
    const loadAdditionalDetails = async () => {
      if (materialDetail?.length) {
        setMaterialCode(materialDetail[0].material_code);
        setMaterialName(materialDetail[0].material_name);
        setMinimumReOrderQty(materialDetail[0].min_reorder_quantity);
        setLeadTimeDemand(materialDetail[0].lead_time_demand);
        setSafetyStock(materialDetail[0].safety_stock);
        setMinimumReOrderLevel(materialDetail[0].min_reorder_level);

        // Parse contact_details if it's a JSON string
        const contactDetailsData = typeof materialDetail[0].vendor_details === 'string'
          ? JSON.parse(materialDetail[0].vendor_details)
          : materialDetail[0].vendor_details;
        setVendors(Array.isArray(contactDetailsData) ? contactDetailsData : []);
        setHsncode(materialDetail[0].hsncode);
        setGstpercentage(materialDetail[0].gst_percent);
        setPurchaseType(materialDetail[0].purchase_type);

        await loadMaterialCategoryByID(materialDetail[0].id_category);
        await loadUOMByID(materialDetail[0].id_uom);
        await loadMaterialShadeByID(materialDetail[0].id_shade);
        await loadMaterialSubCategoryByID(materialDetail[0].id_category, materialDetail[0].id_subcategory);

        setHideSave(false);


        // 💥 convert array to object for formData
        const attrObject = convertAttributesToObject(materialDetail[0].material_attributes);
        setFormData(attrObject);


      }
    };

    loadAdditionalDetails();
  }, [materialDetail]);

  useEffect(() => {
    if (leadTimeDemand > 0 && safetyStock > 0) {
      calculateReOrderLevel(leadTimeDemand, safetyStock);
    }

  }, [leadTimeDemand, safetyStock]);


  const callback = () => {
    handlecallback();
  }

  const [hideAdd, setHideAdd] = useState(true);
  const [hideSave, setHideSave] = useState(false);

  const handleAddNewMaterial = () => {
    setEditMaterialID(0);
    setMinimumReOrderQty(0);
    setSafetyStock(0);
    setLeadTimeDemand(0);
    loadUOMByID(0);
    // loadMaterialCategoryByID(0);
    generateMaterialCodeByCategory(selectedCategory.id_material_category, selectedCategory.category_code);
    setVendors([]);
    setMaterialName('');
    setHideAdd(true);
    setMinimumReOrderLevel(0);
    setHideSave(false);
    setHsncode('');
    setGstpercentage(0);
    setPurchaseType('Import'); // Reset to default value
    setSelectedShadeID(0);
    setSelectedShade(null);

  }

  const callApi = async (url, method, headers = {}, body = null) => {
  const options = {
    method,
    headers,
  };

  if (body) {
    options.body = JSON.stringify(body);
  }

  const response = await fetch(url, options);

  // Read response safely (text OR json)
  const contentType = response.headers.get("content-type");
  const responseData = contentType && contentType.includes("application/json")
    ? await response.json()
    : await response.text();

  // ❌ DO NOT throw new Error()
  if (!response.ok) {
    throw {
      status: response.status,
      data: responseData
    };
  }

  return responseData;
};

  

  const handleSaveAndDraft = () => {


    let company_id = localStorage.getItem('companyid');
    let selectedmode = editMaterialID === 0 ? 0 : 1;
    let id_material = editMaterialID === 0 ? 0 : editMaterialID;

    // Validation checks
    if (!company_id) {
      callMessage('warning', 'Company ID is required', 'Validation');
      return;
    }

    // if (!purchaseType || purchaseType.trim() === '') {
    //   callMessage('error', 'Purchase Type is required', 'Error');
    //   return;
    // }

    if (!selectedCategoryID || selectedCategoryID === 0) {
      callMessage('warning', 'Material category is required', 'Validation');
      return;
    }

    // if (!selectedSubCategoryID || selectedSubCategoryID === 0) {
    //   callMessage('error', 'Material sub-category is required', 'Error');
    //   return;
    // }

    if (!materialCode || materialCode.trim() === '') {
      callMessage('warning', 'Material code is required', 'Validation');
      return;
    }

    if (!materialName || materialName.trim() === '') {
      callMessage('warning', 'Material Description is required', 'Validation');
      return;
    }

    if (!selectedUOMID || selectedUOMID === 0) {
      callMessage('warning', 'UOM is required', 'Validation');
      return;
    }

    // if (!hsncode || hsncode.trim() === '') {
    //   callMessage('error', 'HSN Code is required', 'Error');
    //   return;
    // }
    // if (!gstpercentage || gstpercentage === 0) {
    //   callMessage('error', 'GST Percentage is required', 'Error');
    //   return;
    // }
    // if (!selectedShadeID || selectedShadeID === 0) {
    //   callMessage('error', 'Shade is required', 'Error');
    //   return;
    // }

    // if (!minimumReOrderQty || minimumReOrderQty === 0) {
    //   callMessage('error', 'Minimum ReOrder Qty is required', 'Error');
    //   return;
    // }

    // if (!safetyStock || safetyStock === 0) {
    //   callMessage('error', 'Safety Stock is required', 'Error');
    //   return;
    // }

    // if (!minimumReOrderLevel || minimumReOrderLevel === 0) {
    //   callMessage('error', 'Minimum ReOrderLevel is required', 'Error');
    //   return;
    // }


    const requestBody = {
      p_companyid: company_id,
      p_plantid: 1,
      p_mode: selectedmode,
      p_id_material: id_material,
      p_id_uom: selectedUOMID,
      p_id_category: selectedCategoryID,
      p_min_reorder_quantity: minimumReOrderQty,
      p_lead_time_demand: leadTimeDemand,
      p_safety_stock: safetyStock,
      p_min_reorder_level: minimumReOrderLevel,
      p_matrial_code: materialCode,
      p_matrial_name: materialName,
      p_vendor_list: vendors,
      p_hsn_code: hsncode,
      p_gst_percent: gstpercentage,
      p_purchase_type: purchaseType,
      p_id_shade: selectedShadeID === 0 ? null : selectedShadeID,
      p_attribute_values: Object.entries(formData) // formData came from DynamicForm
        .map(([attrName, value]) => ({
          attribute_name: attrName,
          value_text: value ?? ""          // keep DB happy with empty string, not null
        })),
      p_subcategoryid: selectedSubCategoryID === 0 ? null : selectedSubCategoryID,

    }

 callApi(
  API_ENDPOINTS.MATERIAL_GRUD_PROCESS,
  'POST',
  { 'Content-Type': 'application/json' },
  requestBody
)
.then(data => {
  const msg = editMaterialID === 0
    ? 'New Material Added Successfully'
    : 'Material Updated Successfully';

  callMessage('info', msg, 'Success');
})
.catch(err => {
  const backendMsg = err?.data || 'Something went wrong';

  if (
    typeof backendMsg === 'string' &&
    backendMsg.toLowerCase().includes('already exists')
  ) {
    callMessage('warning', backendMsg.Message, 'Validation');
  } else {
    callMessage('error', backendMsg.Message, 'Error');
  }
});



    // callApi(API_ENDPOINTS.MATERIAL_GRUD_PROCESS, 'POST', { 'Content-Type': 'application/json' }, requestBody)
    //   // .then(data => {
    //   //   if (data && data.length > 0) {
    //   //     let msg = editMaterialID === 0 ? 'New Material Added Successfully' : 'Update Material Added Successfully';
    //   //     setHideSave(true);
    //   //     setHideAdd(false);
    //   //     callMessage('info', msg, 'info');
    //   //   }
    //   // })
    //   .then(data => {
    //     if (data?.includes('already exists')) {
    //       callMessage('warning', data, 'Validation');
    //       return;
    //     }

    //     let msg = editMaterialID === 0
    //       ? 'New Material Added Successfully'
    //       : 'Material Updated Successfully';

    //     callMessage('info', msg, 'Success');
    //   })

    //   .catch(error => { callMessage('error', error.message, 'Error'); });
  };

  const callMessage = (serverityval, msg, title) => {
    setParentRollSeverityvalue(serverityval);
    setParentRollMessageValue(msg);
    setParentRollAlertTitleValue(title);
    setParentRollMsgOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    loadMaterialCategoryByID(0);  // or whatever logic you use here  
    setSelectedCategory(null);
    setSelectedCategoryID(0);

    // const para = {
    //     p_companyid: localStorage.getItem('companyid'),
    //     p_plantid: 1,
    // }
    // callApi(API_ENDPOINTS.PROD_MANAGEMENT_GET_OPERATOR, 'POST', { 'Content-Type': 'application/json' }, para)
    //     .then(data => {
    //         if (data && data.length > 0) {
    //             setOperator(data);
    //             setSelectedOperator(data[0]);
    //             setSelectedOperatorName(data[0].operator_code);
    //             setWinderOperators(data[0].operator_code);
    //         }
    //     })
    //     .catch(error => {
    //         alert(error.message);
    //     });
  };

  const handleCloseModalMaterialShade = () => {
    setIsModalOpenShadeMaster(false);
    loadMaterialShadeByID(0);  // or whatever logic you use here  
  }

  const handleCloseModalMaterialCategoryAttr = () => {
    setIsModalOpenCategoryAttr(false);

  }

  const handleCloseModalMaterialsubcategory = () => {
    setIsModalOpenSubCategory(false);

  }

  // 🔍 Simple HSN Validator
  const validateHSN = (value) => {

    const validLengths = [4, 6, 8];

    if (!validLengths.includes(value.length)) {
      setHsncode(''); // Clear the input if invalid
      return 'HSN code must be 4, 6, or 8 digits long';
    }
    return '';
  };



  const CustomTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} classes={{ popper: className }} arrow placement="right-start" />
  ))({
    [`& .MuiTooltip-tooltip`]: {
      backgroundColor: colors.blueAccent[500],
      color: 'white',
      fontSize: '14px',
      borderRadius: '10px',
      padding: '10px',

    },
    [`& .MuiTooltip-arrow`]: {
      color: colors.blueAccent[500],
    },
  });

  useEffect(() => {
    if (selectedCategory && materialSubCategory.length === 0) {
      setTooltipInfo('No sub category available, create new');
      setShowTooltip(true);

      setTimeout(() => {
        createSubCategoryBtnRef.current?.focus();
      }, 100);
    } else {
      setTooltipInfo('');
      setShowTooltip(false);

    }
  }, [materialSubCategory, selectedCategory]);



  return (<>


    <Box padding={0}>

      <Header title={editMaterialID == 0 ? 'New Material' : 'Edit Material'} subtitle="" callback={callback} />
      <Divider />


      {/* {editMaterialID > 0 && (
        <>
          <PurchaseReceiveActionMenu selectedButtonName={selectedButtonName} setSelectedButtonName={setSelectedButtonName} />
          <Divider />
        </>
      )} */}

      <CallAlertBar parentRollMsgOpen={parentRollMsgOpen} setParentRollMsgOpen={setParentRollMsgOpen} parentRollSeverityvalue={parentRollSeverityvalue}
        setParentRollSeverityvalue={setParentRollSeverityvalue} parentRollAlertTitleValue={parentRollAlertTitleValue}
        setParentRollAlertTitleValue={setParentRollAlertTitleValue} parentRollMessageValue={parentRollMessageValue} setParentRollMessageValue={setParentRollMessageValue} />

      <Box
        sx={{
          display: 'flex',
          justifyContent: 'flex-end',
          px: 1,
          py: 1
        }}
      >
        <Typography variant="h6"  >
          <span style={{ color: 'red' }}>*</span> Mandatory fields
        </Typography>
      </Box>
      {/* 
      <Grid container>
        <Grid item xs={12} sm={12} md={12} lg={12} xl={12} sx={{ backgroundColor: colors.primary[400] }}  >
          <Grid container padding="10px 0px 10px 20px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center" >
            <Grid item xs={12} sm={11} md={1.6} lg={1.8} xl={1} display="flex-start" justifyContent="center" >
              <Typography variant="h6" fontSize={14} marginTop={0} textAlign="left">
                Purchase Type
              </Typography>
            </Grid>


            <Grid item xs={12} sm={11} md={1.6} lg={2.5} xl={2} display="flex-start" justifyContent="center" >
              <Autocomplete
                disablePortal
                options={purchaseOptions}
                value={purchaseType}
                onChange={(event, newValue) => setPurchaseType(newValue)}
                renderInput={(params) => (
                  <TextField {...params} size='small' color="secondary" />
                )}
                disabled={editMaterialID !== 0} // Disable if editing an existing material
              />
            </Grid>




          </Grid>
        </Grid>
      </Grid> */}
      <Box
        sx={{
          padding: "5px",
          borderRadius: "10px",
          maxHeight: {
            xs: '72vh', // Extra small devices (phones)
            sm: '72vh', // Small devices (tablets)
            md: '74vh', // Medium devices (small laptops)
            lg: '74vh', // Large devices (desktops)
            xl: '82vh', // Extra large devices (large desktops)
          },
          overflowY: 'auto', // Add overflowY: 'auto' to enable vertical scrolling
          '&::-webkit-scrollbar': {
            width: '8px',
          },
          '&::-webkit-scrollbar-track': {
            background: colors.primary[400],
            borderRadius: '10px',
          },
          '&::-webkit-scrollbar-thumb': {
            background: colors.blueAccent[600],
            borderRadius: '10px',
            '&:hover': {
              background: colors.blueAccent[800],
            },
          },
          '&::-webkit-scrollbar-corner': {
            background: colors.primary[700],
          }
        }}>

        <Grid container>



          <Grid item xs={12} xl={12} >
            <Grid container padding="10px 0px 0px 20px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center"          >

              <Grid item xs={12} sm={11} md={1.6} lg={1.8} xl={1.8} display="flex-start" justifyContent="center" >


                <Typography variant="h6" fontSize={14} marginTop={0} textAlign="left">
                  Category  <span style={{ color: 'red' }}>*</span>
                  <CustomTooltip
                    title={
                      <span>
                        <b>Category helps classify materials based on their role.</b><br />
                        - <b>Raw Materials:</b> Used directly in production (e.g., pulp, chemicals).<br />
                        - <b>Finished Goods:</b> Final products ready for sale.<br />
                        - <b>Packing Materials:</b> Used for packaging finished goods.<br />
                        - <b>Consumables:</b> Used in operations, not in the final product.<br />
                        - <b>Software:</b> Licensed tools used in business processes.<br />
                        - <b>Spare Parts:</b> Components used to maintain or repair machines.
                      </span>}
                  >
                    <IconButton sx={{ marginLeft: "5px" }}>
                      <InfoOutlinedIcon sx={{ color: colors.blueAccent[500], fontSize: "16px" }} />
                    </IconButton>
                  </CustomTooltip>


                </Typography>

              </Grid>

              <Grid item xs={12} sm={11} md={3.8} lg={2.5} xl={2}>

                <Autocomplete
                  size="small"
                  fullWidth
                  options={materialCategory}
                  value={selectedCategory}
                  onChange={(event, newValue) => {
                    setSelectedCategory(newValue);
                    setSelectedCategoryID(newValue?.id_material_category || null);
                    if (newValue) {
                      generateMaterialCodeByCategory(newValue.id_material_category, newValue.category_code);
                      loadMaterialSubCategoryByID(newValue.id_material_category);
                    } else {
                      setMaterialCode("");
                    }
                  }}
                  getOptionLabel={(option) => option.description || ''}
                  renderInput={(params) => (
                    <TextField {...params} label="" required variant="outlined" color="secondary" />
                  )}
                />

              </Grid>

              <Grid item xs={12} sm={11} md={3.8} lg={.5} xl={1.5}>
                <Tooltip title="Add New Category" arrow>
                  <IconButton style={{ fontSize: 5 }} size="small" color="secondary" onClick={handleOpenModal} >
                    <AddCircleIcon />
                  </IconButton>
                </Tooltip>
              </Grid>


            </Grid>
          </Grid>

          {/* <Grid item xs={12} xl={12} >
            <Grid container padding="10px 0px 0px 20px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center"          >
              <Grid item xs={12} sm={11} md={1.6} lg={1.8} xl={1.8} display="flex-start" justifyContent="center" >
                <Typography variant="h6" fontSize={14} marginTop={0} textAlign="left">
                  Sub Category
                </Typography>
              </Grid>

              <Grid item xs={12} sm={11} md={3.8} lg={2.5} xl={2}>
                <Autocomplete
                  size="small"
                  fullWidth
                  options={materialSubCategory}
                  value={selectedSubCategory}
                  onChange={(event, newValue) => {
                    setSelectedSubCategory(newValue);
                    setSelectedSubCategoryID(newValue?.id_material_subcategory || null);
                  
                  }}
                  getOptionLabel={(option) => option.description || ''}
                  renderInput={(params) => (
                    <TextField {...params} label="" required variant="outlined" color="secondary" />
                  )}
                />

              </Grid>

              <Grid item xs={12} sm={12} md={0.5} lg={0.5} xl={0.5}>
                {
                  !showTooltip ? (
                    <Tooltip title="Create Sub Category" arrow>
                      <IconButton
                        size="small"
                        color="secondary"
                        onClick={handleOpenModalSubCategory}
                      >
                        <AddCircleIcon />
                      </IconButton>
                    </Tooltip>
                  ) : (
                    <Tooltip
                      title={tooltipInfo}
                      arrow
                      open={showTooltip}
                    >
                      <IconButton
                        ref={createSubCategoryBtnRef}
                        size="small"
                        color="secondary"
                        onClick={handleOpenModalSubCategory}
                        onBlur={() => setShowTooltip(false)}
                      >
                        <AddCircleIcon />
                      </IconButton>
                    </Tooltip>
                  )
                }
              </Grid>


              
              <Grid item>
                <Divider
                  orientation="vertical"
                  flexItem
                  sx={{
                    height: 28,           // 💥 This is the key line
                    borderWidth: 1,
                    borderColor: '#476596',  // You can darken it more if needed
                    mx: 1
                  }}
                />
              </Grid>

              <Grid item xs={12} sm={12} md={2} lg={2} xl={2}>
                <Tooltip title="Add Sub Category Attributes" arrow>
                  <Button
                    variant="contained"
                    size="small"
                    color="secondary"
                    startIcon={<AddCircleOutlineIcon />}
                    onClick={handleOpenModalCategoryAttr}
                  >
                    Attributes
                  </Button>
                </Tooltip>
              </Grid>

            </Grid>
          </Grid> */}



          <Grid item xs={12} xl={12}>
            <Grid container padding="10px 0px 0px 20px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center" >
              <Grid item xs={12} sm={12} md={1.6} lg={1.8} xl={1.8} display="flex-start" justifyContent="center">
                <Typography required variant="h6" fontSize={14} marginTop={0} textAlign="left">
                  Material Code <span style={{ color: 'red' }}>*</span>
                </Typography>
              </Grid>

              <Grid item xs={12} sm={12} md={2.5} lg={2.5} xl={2.5}>
                <TextField value={materialCode} fullWidth size="small" label="" required variant="outlined" color="secondary" />
              </Grid>
            </Grid>
          </Grid>

          <Grid item xs={12} xl={12} >
            <Grid container padding="10px 0px 0px 20px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center"          >

              <Grid item xs={12} sm={11} md={1.8} lg={1.8} xl={1.8} display="flex-start" justifyContent="center" >
                <Typography variant="h6" fontSize={14} marginTop={0} textAlign="left">
                  Material Name <span style={{ color: 'red' }}>*</span>
                </Typography>
              </Grid>

              <Grid item xs={12} sm={12} md={2.5} lg={2.5} xl={2.5}>
                <TextField fullWidth type="text" size="small" value={materialName} onChange={(e) => { setMaterialName(e.target.value) }} color="secondary" />
              </Grid>

              <Grid item xs={12} sm={12} md={2.5} lg={2} xl={2}>
                <Autocomplete
                  size="small"
                  fullWidth
                  options={uom}
                  value={selectedUOM}
                  onChange={(event, newValue) => {
                    if (!newValue) {
                      setSelectedUOM(null);
                      setSelectedUOMID(null);
                      return;
                    }
                    else {
                      setSelectedUOM(newValue);
                      setSelectedUOMID(newValue.id_uom);
                    }

                  }}
                  getOptionLabel={(option) => option.name || ''}
                  renderInput={(params) => (
                    <TextField {...params} label="Select UOM" required variant="outlined" color="secondary" />
                  )}
                />
              </Grid>

            </Grid>
          </Grid>



          {/* <Grid item xs={12} xl={12} >
            <Grid container padding="10px 0px 0px 20px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center"          >

              <Grid item xs={12} sm={11} md={1.6} lg={1.8} xl={1} display="flex-start" justifyContent="center" >
                <Typography variant="h6" fontSize={14} marginTop={0} textAlign="left">
                  UOM
                </Typography>
              </Grid>

              <Grid item xs={12} sm={11} md={2.5} lg={2.5} xl={2}>
                <Autocomplete
                  size="small"
                  fullWidth
                  options={uom}
                  value={selectedUOM}
                  onChange={(event, newValue) => {
                    setSelectedUOM(newValue);
                    setSelectedUOMID(newValue.id_uom);

                  }}
                  getOptionLabel={(option) => option.name || ''}
                  renderInput={(params) => (
                    <TextField {...params} label="" required variant="outlined" color="secondary" />
                  )}
                />
              </Grid>

            </Grid>
          </Grid> */}

          {/* Conditionally render dynamic form only when category is selected */}
          {selectedCategoryID && selectedSubCategoryID && (

            <DynamicFormByCategory selectedCategoryId={selectedCategoryID} selectedSubCategoryID={selectedSubCategoryID} formData={formData} setFormData={setFormData} />

          )}

          <Grid item xs={12} xl={12} >
            <Grid container padding="10px 0px 0px 20px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center"          >

              <Grid item xs={12} sm={12} md={1.8} lg={1.8} xl={1.8} display="flex-start" justifyContent="center" >
                <Typography variant="h6" fontSize={14} marginTop={0} textAlign="left">
                  HSN Code
                </Typography>
              </Grid>

              <Grid item xs={12} sm={12} md={2.5} lg={2.5} xl={2.5}>
                <TextField
                  variant="outlined"
                  type="number"                // FYI: maxLength won’t work on type="number"
                  fullWidth
                  color="secondary"
                  size="small"
                  value={hsncode}
                  onChange={handleChange}      // keep passing the whole event
                  onBlur={(e) => setError(validateHSN(e.target.value))}
                  error={Boolean(error)}
                  helperText={error || null}   // ← key line: only show helper when error exists
                  inputProps={{
                    maxLength: 12,              // switch to type="text" if you really need this
                    inputMode: 'numeric',      // mobile-friendly numeric keypad
                    pattern: '[0-9]*'
                  }}
                />


              </Grid>

            </Grid>
          </Grid>

          <Grid item xs={12} xl={12} >
            <Grid container padding="10px 0px 0px 20px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center"          >

              <Grid item xs={12} sm={12} md={1.8} lg={1.8} xl={1.8} display="flex-start" justifyContent="center" >
                <Typography variant="h6" fontSize={14} marginTop={0} textAlign="left">
                  GST ( % )
                </Typography>
              </Grid>

              <Grid item xs={12} sm={12} md={2.5} lg={2.5} xl={2.5}>
                <TextField fullWidth type="number" size="small" value={gstpercentage} onChange={(e) => { setGstpercentage(e.target.value) }} color="secondary" />
              </Grid>

            </Grid>
          </Grid>

          <Grid item xs={12} xl={12} >
            <Grid container padding="10px 0px 0px 20px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center"          >

              <Grid item xs={12} sm={12} md={1.8} lg={1.8} xl={1.8} display="flex-start" justifyContent="center" >
                <Typography variant="h6" fontSize={14} marginTop={0} textAlign="left">
                  Shade
                </Typography>
              </Grid>

              <Grid item xs={12} sm={12} md={2.5} lg={2.5} xl={2.5}>

                <Autocomplete
                  size="small"
                  fullWidth
                  options={materialShade}
                  value={selectedShade}
                  onChange={(event, newValue) => {
                    setSelectedShade(newValue);
                    setSelectedShadeID(newValue?.id_material_shade || null);
                    // if (newValue) {
                    //   generateMaterialCodeByCategory(newValue.id_material_category, newValue.description);
                    // } else {
                    //   setMaterialCode("");
                    // }
                  }}
                  getOptionLabel={(option) => option.description || ''}
                  renderInput={(params) => (
                    <TextField {...params} label="" required variant="outlined" color="secondary" />
                  )}
                />

              </Grid>

              <Grid item xs={12} sm={12} md={2} lg={2} xl={2}>
                <Tooltip title="Add New Shade" arrow>
                  <IconButton style={{ fontSize: 5 }} size="small" color="secondary" onClick={handleOpenModalShadeMaster} >
                    <AddCircleIcon />
                  </IconButton>
                </Tooltip>
              </Grid>

            </Grid>
          </Grid>


          <Grid item xs={12} xl={12} >
            <Grid container padding="10px 0px 0px 20px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center"          >

              <Grid item xs={12} sm={12} md={1.8} lg={1.8} xl={1.8}>
                <TooltipLabel
                  label="Minimum Re-order Qty"
                  tooltip="Minimum quantity that must be ordered each time a purchase order is raised."
                />
              </Grid>


              <Grid item xs={12} sm={11} md={2.5} lg={2.5} xl={2.5}>
                <TextField fullWidth type="number" size="small" value={minimumReOrderQty} onChange={(e) => { setMinimumReOrderQty(e.target.value) }} color="secondary" />
              </Grid>

            </Grid>
          </Grid>

          <Grid item xs={12} xl={12} >
            <Grid container padding="10px 0px 0px 20px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center"          >

              <Grid item xs={12} sm={12} md={1.8} lg={1.8} xl={1.8}>
                <TooltipLabel
                  label="Lead Time Demand"
                  tooltip="Expected material consumption during supplier lead time."
                />

              </Grid>

              <Grid item xs={12} sm={12} md={2.5} lg={2.5} xl={2.5}>
                <TextField fullWidth type="number" size="small" value={leadTimeDemand} onChange={(e) => { setLeadTimeDemand(e.target.value) }} color="secondary" />
              </Grid>

            </Grid>
          </Grid>

          <Grid item xs={12} xl={12} >
            <Grid container padding="10px 0px 0px 20px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center"          >

              <Grid item xs={12} sm={12} md={1.8} lg={1.8} xl={1.8}>
                <TooltipLabel
                  label="Safety Stock"
                  tooltip="Extra buffer stock to handle delays or sudden demand."
                />

              </Grid>

              <Grid item xs={12} sm={12} md={2.5} lg={2.5} xl={2.5}>
                <TextField fullWidth type="number" size="small" value={safetyStock} onChange={(e) => { setSafetyStock(e.target.value) }} color="secondary" />
              </Grid>

            </Grid>
          </Grid>
          <Grid item xs={12} xl={12} >
            <Grid container padding="10px 0px 0px 20px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center"          >

              <Grid item xs={12} sm={12} md={1.8} lg={1.8} xl={1.8}>
                <TooltipLabel
                  label="Minimum Re-order Level"
                  tooltip="Auto-calculated as Lead Time Demand + Safety Stock. Used to trigger purchase."
                />


              </Grid>

              <Grid item xs={12} sm={12} md={2.5} lg={2.5} xl={2.5}>
                <TextField fullWidth type="number" size="small" disabled value={minimumReOrderLevel} onChange={(e) => { setMinimumReOrderLevel(e.target.value) }} color="secondary" />
              </Grid>

            </Grid>
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={12} xl={12} >
            <Grid container padding="10px 0px 0px 20px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center"          >

              <Grid item xs={12} sm={12} md={5} lg={5} xl={5} display="flex-start" justifyContent="center">
                <Box mt={1}  >

                  <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                    <Tabs
                      value={value}
                      onChange={handleChange}
                      indicatorColor="secondary"
                      textColor="inherit"
                      variant="contained"
                      aria-label="full width tabs example"
                    >
                      <Tab sx={{ textTransform: "none" }} label="Vendors List" {...a11yProps(0)} />

                    </Tabs>
                  </Box>

                  <SwipeableViews
                    axis={theme.direction === 'rtl' ? 'x-reverse' : 'x'}
                    index={value}
                    onChangeIndex={handleChangeIndex}
                  >



                    <TabPanel value={value} index={0} dir={theme.direction}>
                      <Box>
                        <MaterialWiseVendor vendors={vendors} setVendors={setVendors} />
                      </Box>
                    </TabPanel>
                  </SwipeableViews>
                </Box>

              </Grid>

            </Grid>
          </Grid>


        </Grid>
      </Box>

      <Grid container>

        <Grid item xs={12} sm={12} md={12} lg={12} xl={12} >
          <Box position="fixed" sx={{ top: 'auto', bottom: 0 }}>
            <Toolbar>
              <Button size="small" variant="contained" color="secondary" onClick={handleAddNewMaterial} disabled={hideAdd} startIcon={<AddCircleOutlineIcon />} sx={{ marginLeft: 'auto', textTransform: 'none' }}>Add New </Button>
              <Button size="small" variant="contained" color="secondary" onClick={handleSaveAndDraft} disabled={hideSave} startIcon={<SaveAltIcon />} sx={{ marginLeft: '5px', textTransform: 'none' }}>Save Material</Button>
              <Button size="small" variant="contained" style={{ backgroundColor: "maroon" }} startIcon={<Cancel />} sx={{ marginLeft: '5px', textTransform: 'none' }}>Cancel</Button>
            </Toolbar>
          </Box>
        </Grid>
      </Grid>

      {/* Render modal if isModalOpen is true */}
      {
        isModalOpen && <AddCategory onClose={handleCloseModal} open={isModalOpen} />
      }
      {
        isModalOpenShadeMaster && <AddMaterialShade onClose={handleCloseModalMaterialShade} open={isModalOpenShadeMaster} />
      }
      {
        isModalOpenCategoryAttr && <AddUpdateMaterialAttributes onClose={handleCloseModalMaterialCategoryAttr} open={isModalOpenCategoryAttr} />
      }
      {
        isModalOpenSubCategory && <AddSubCategory onClose={handleCloseModalMaterialsubcategory} open={isModalOpenSubCategory} />
      }

    </Box>

  </>)
}
export default AddNewMaterial;